import { render, staticRenderFns } from "./PopupAddItemToOrder.vue?vue&type=template&id=456af974"
import script from "./PopupAddItemToOrder.vue?vue&type=script&lang=js"
export * from "./PopupAddItemToOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports